import { useAdminSession } from '../../useAdminSession'
import { Checking } from '../Checking'
import { ConsoleLogin } from './ConsoleLogin'
import { ConsoleShell } from './ConsoleShell'

/**
 * The admin console at /console.
 *
 * A second, separate credential from the guest site: one password held by the
 * couple rather than the per-invite codes. Being signed in here grants nothing
 * on the guest site, and vice versa - separate cookies, separate signing keys -
 * so both can be held at once without interfering.
 */
export function Console() {
  const session = useAdminSession()

  if (session.phase === 'checking') return <Checking />

  if (session.phase === 'disabled') {
    return (
      <main className="mx-auto flex min-h-dvh max-w-md items-center px-4">
        <div>
          <h1 className="font-display text-2xl">Console disabled</h1>
          <p className="text-ink-soft mt-3 text-sm">
            The server has no <code className="font-mono">WEDDING_ADMIN_PASSWORD</code> set, so
            there is nothing to sign in to. Set one and restart to enable it.
          </p>
        </div>
      </main>
    )
  }

  if (session.phase === 'locked') {
    return (
      <ConsoleLogin
        onSubmit={(password) => void session.signIn(password)}
        submitting={session.signingIn}
        error={session.error}
      />
    )
  }

  return (
    <ConsoleShell onSignOut={() => void session.signOut()} onSessionLost={session.sessionLost} />
  )
}
